import { FC, PropsWithChildren, useReducer } from 'react';

import { InvoiceDispatchContext, InvoiceStateContext } from '../context/invoice-context';
import { initialInvoiceState, InvoiceReducer } from '../state/invoice.reducer';

export const InvoiceProviders: FC<PropsWithChildren> = ({ children }) => {
   const [state, dispatch] = useReducer(InvoiceReducer, initialInvoiceState);

   return (
      <InvoiceStateContext value={state}>
         <InvoiceDispatchContext value={dispatch}>{children}</InvoiceDispatchContext>
      </InvoiceStateContext>
   );
};
